// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var InvoiceCorrectionController = function ($scope, $routeParams, $http, $location, gettextCatalog, gettext, InvoiceCorrection, Customer) {
    $scope.saved = false;

    $http({
        method: "GET",
        url: "/api/v1/legalEntity/isExtendedLineItemInformation",
        params: null,
        data: null,
        headers: {},
        cache: false
    }).then(function (response) {
        $scope.showExtendedBookedQuantityInformation = response.data;
    });

    function finish(data) {
        if (data.InvoiceId) {
            $location.path("/invoices/" + data.InvoiceId);
        } else {
            $location.path("/invoice-drafts/" + data.Id);
        }
    };

    $scope.save = function () {
        if ($scope.saved)
            return;
        $scope.saved = true;

        $http({
            method: "POST",
            url: "/api/v1/invoices/" + $routeParams.invoiceId + "/correction",
            cache: false
        }).then(function (response) {
            finish(response.data[0]);
            if (response.data.length > 1) {
                var message = response.data[0].InvoiceId
                    ? gettextCatalog.getString(gettext("Produced more than one corrected invoice!"))
                    : gettextCatalog.getString(gettext("Produced more than one corrected draft invoice!"));
                var additionalMessage = gettextCatalog.getString(gettext("Please check Contract Ledger!"));
                $scope.onlyOk(gettextCatalog.getString(gettext("Invoice Correction")), message + ' ' + additionalMessage);
            }
        }, function () {
            $scope.saved = false;
        });
    };

    $scope.correctionInvoiceDraft = InvoiceCorrection.get({ invoiceId: $routeParams.invoiceId }, function () {
        $scope.correctionInvoiceDraft.IsInvoice = $scope.correctionInvoiceDraft.Entries.reduce(function (result, entry) {return result + entry.TotalGross; }, 0) >= 0;
        $scope.sign = $scope.correctionInvoiceDraft.IsInvoice ? +1 : -1;
        Customer.get({ customerId: $scope.correctionInvoiceDraft.CustomerId }, function (customer) {
            $scope.correctionInvoiceDraft.isCustomerLocked = customer.IsLocked;
        });
    });

    $scope.backlink = "#/invoices/" + $routeParams.invoiceId;
};
InvoiceCorrectionController.$inject = ['$scope', '$routeParams', '$http', '$location', 'gettextCatalog', 'gettext', 'InvoiceCorrection', 'Customer'];
